import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentsPost = {
    path: "/attachments",
    method: RouteHttpVerb.POST
};
export { locationRestAttachmentsPost };
